//
// Donate Button - Confetti burst & party effects
// --------------------------------------------------

const brandColors = [
    '#6D00A3', // purple-core
    '#FFA800', // orange-primary
    '#FE2835', // red-primary
    '#C247FF', // purple-primary
    '#17E58F', // green-primary
    '#00A3FF', // blue-primary
    '#FFD43C', // yellow-primary
];

const geckoSVG = `<svg viewBox="0 0 45 42" xmlns="http://www.w3.org/2000/svg"><path d="M24.4803 34.3187L29.455 41.7808C32.9381 40.8119 36.3785 38.0356 36.7342 37.6353C37.0189 37.3151 37.0604 37.2647 37.0456 37.2796L33.0875 29.4524C33.132 29.3339 33.2565 29.0166 33.3988 28.6964C33.5767 28.2962 33.7101 27.3178 33.7991 26.6062C33.888 25.8947 33.6657 24.9608 33.7546 24.0268C33.8436 23.0929 34.5106 22.4703 35.3111 21.8477C36.1116 21.2251 36.8232 21.3585 38.6466 21.4475C40.4699 21.5364 41.8485 21.1806 43.0493 20.6914C44.25 20.2022 44.6195 19.5336 44.6948 17.5784C44.7604 15.8751 44.0722 14.7766 43.0938 13.4869C42.1154 12.1972 40.8257 11.8415 39.7139 11.708C38.6021 11.5746 37.8905 12.1528 36.8677 13.0422C35.8448 13.9317 35.2222 16.1108 34.2438 17.2226C33.2654 18.3344 32.5539 18.3789 31.7978 18.2455C31.0418 18.112 31.0418 17.4894 30.6416 16.2442C30.2413 14.999 30.6416 13.6648 31.1752 12.1083C31.7089 10.5518 33.7546 8.77288 34.733 7.61661C35.7114 6.46033 35.578 4.68144 35.2222 3.34728C34.8664 2.01311 32.5983 0.767892 31.4421 0.545531C30.2858 0.32317 28.5958 0.501059 27.5285 1.0792C26.4612 1.65734 26.1943 2.63572 25.883 3.92542C25.5717 5.21511 26.728 8.01686 26.817 10.4628C26.9059 12.9088 25.7496 14.6877 25.3049 15.0879C24.8602 15.4882 24.1486 15.7105 23.2592 15.5771C22.3697 15.4437 22.014 14.7322 21.08 13.8872C20.1461 13.0422 19.0343 10.8186 18.812 9.75127C18.5896 8.68394 18.4117 6.54928 18.4562 5.65983C18.5007 4.77039 17.6557 2.50231 16.6773 1.65734C15.6989 0.812364 14.986 0.732775 13.3419 0.812364C11.9683 0.878857 10.7089 1.81933 9.65069 2.81361C8.83641 3.57873 8.49441 5.83772 8.85019 7.08294C9.20596 8.32816 11.3406 9.75127 12.9416 10.8186C14.5426 11.8859 14.4092 11.9304 15.7878 13.5314C17.1665 15.1324 17.5223 18.0676 17.4333 18.6457C17.3444 19.2239 16.8997 19.9354 16.4549 20.2912C16.0992 20.5758 14.8859 20.5721 14.3237 20.5347C13.3391 20.4829 11.0072 19.4465 10.3854 18.9801C9.76356 18.5137 7.48349 16.13 6.65437 15.6637C5.82526 15.1973 5.46253 15.1455 4.52977 15.0936C3.59701 15.0418 2.56062 15.5082 1.78333 16.13C1.00603 16.7519 0.176911 18.6692 0.0214522 19.9129C-0.134007 21.1565 0.539649 23.7475 2.56062 24.473C4.58158 25.1985 6.65437 24.473 8.62352 24.1103C10.5927 23.7475 11.0072 24.1103 12.3545 24.473C13.7018 24.8357 14.9455 25.9758 15.3083 26.5458C15.671 27.1158 15.3083 28.1522 14.9455 28.6186C14.5828 29.0849 13.3391 29.3959 11.0072 29.344C8.67534 29.2922 8.36443 29.4995 7.12076 29.9659C5.87708 30.4323 5.25525 32.8678 5.46253 34.3187C5.66981 35.7697 6.7062 37.5834 9.29718 38.6716C11.8882 39.7598 13.4946 37.4279 14.3237 35.977C15.1528 34.526 15.671 32.8678 17.0701 32.3496C18.4693 31.8314 19.3502 32.2978 20.3866 32.8678C21.2157 33.3238 23.4612 34.0251 24.4803 34.3187Z"/></svg>`;

const thankYouMessages = [
    "You're AWESOME! ✨",
    "Gecko Power! 🦎",
    "You legend! 🌟",
    "Imagination WIN! 🎭",
    "Big Heart Energy! 💜",
    "IMAGINE BIGGER! 🎉",
];

function randomFromArray(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

function random(min, max) {
    return Math.random() * (max - min) + min;
}

// Split the donate text into individual letter spans for wave animation
function initLetterSpans(btn) {
    const textContainer = btn.querySelector('.donate-btn__text');
    if (!textContainer || textContainer.dataset.split === 'true') return;

    const text = textContainer.textContent.trim();
    textContainer.innerHTML = '';
    textContainer.dataset.split = 'true';

    for (const char of text) {
        const span = document.createElement('span');
        span.textContent = char;
        textContainer.appendChild(span);
    }
}

// Create a single confetti particle element
function createParticle(x, y) {
    const particle = document.createElement('div');
    particle.className = 'donate-confetti-particle';

    const color = randomFromArray(brandColors);
    const size = random(8, 22);
    const shape = randomFromArray(['circle', 'star', 'gecko', 'square', 'heart']);

    particle.style.left = x + 'px';
    particle.style.top = y + 'px';

    if (shape === 'gecko') {
        particle.innerHTML = geckoSVG;
        particle.style.width = size * 1.5 + 'px';
        particle.style.height = size * 1.5 + 'px';
        particle.querySelector('path').setAttribute('fill', color);
    } else if (shape === 'heart') {
        particle.innerHTML = '💜';
        particle.style.fontSize = size + 'px';
        particle.style.lineHeight = '1';
    } else if (shape === 'star') {
        particle.innerHTML = '★';
        particle.style.fontSize = size * 1.3 + 'px';
        particle.style.lineHeight = '1';
        particle.style.color = color;
    } else if (shape === 'square') {
        particle.style.width = size + 'px';
        particle.style.height = size * 0.6 + 'px';
        particle.style.backgroundColor = color;
        particle.style.borderRadius = '2px';
    } else {
        particle.style.width = size + 'px';
        particle.style.height = size + 'px';
        particle.style.backgroundColor = color;
        particle.style.borderRadius = '50%';
    }

    return particle;
}

// Pre-compute physics keyframes for a particle and animate via Web Animations API
// (iOS Safari doesn't reliably run rAF-driven style updates on fixed elements)
function animateParticle(particle, delay) {
    const totalFrames = 60;
    const angle = random(0, Math.PI * 2);
    const velocity = random(4, 14);
    const gravity = 0.3;
    const friction = 0.98;
    const rotationSpeed = random(-15, 15);

    let vx = Math.cos(angle) * velocity;
    let vy = Math.sin(angle) * velocity - random(2, 8);
    let rotation = random(0, 360);
    let dx = 0;
    let dy = 0;

    // Pre-compute all positions
    const keyframes = [];
    for (let frame = 0; frame <= totalFrames; frame++) {
        const progress = frame / totalFrames;
        const opacity = Math.max(0, 1 - progress);
        const scale = 0.5 + opacity * 0.5;

        keyframes.push({
            transform: `translate(${dx}px, ${dy}px) rotate(${rotation}deg) scale(${scale})`,
            opacity: opacity,
        });

        vx *= friction;
        vy += gravity;
        vy *= friction;
        dx += vx;
        dy += vy;
        rotation += rotationSpeed;
    }

    const animation = particle.animate(keyframes, {
        duration: 1000,
        easing: 'linear',
        fill: 'forwards',
        delay: delay || 0,
    });

    animation.onfinish = () => particle.remove();
}

// The big confetti burst!
function confettiBurst(btn) {
    const rect = btn.getBoundingClientRect();
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    const centerX = rect.left + scrollX + rect.width / 2;
    const centerY = rect.top + scrollY + rect.height / 2;
    const particleCount = 40;

    for (let i = 0; i < particleCount; i++) {
        const offsetX = random(-rect.width / 2, rect.width / 2);
        const offsetY = random(-rect.height / 2, rect.height / 2);
        const particle = createParticle(centerX + offsetX, centerY + offsetY);
        document.body.appendChild(particle);
        animateParticle(particle, random(0, 80));
    }
}

// Show floating thank you message
function showThankYou(btn) {
    const thankYou = btn.querySelector('.donate-btn__thankyou');
    if (!thankYou) return;

    thankYou.textContent = randomFromArray(thankYouMessages);
    thankYou.style.animation = 'none';
    // Force reflow
    void thankYou.offsetWidth;
    thankYou.style.animation = '';

    btn.classList.add('is-exploding');
    setTimeout(() => {
        btn.classList.remove('is-exploding');
    }, 1500);
}

// Initialize everything
window.addEventListener('load', () => {
    const donateBtn = document.querySelector('.donate-btn');
    if (!donateBtn) return;

    initLetterSpans(donateBtn);

    donateBtn.addEventListener('click', (e) => {
        e.preventDefault();
        confettiBurst(donateBtn);
        showThankYou(donateBtn);

        // Delay navigation so the confetti burst plays before leaving the page
        const href = donateBtn.getAttribute('href');
        if (href) {
            setTimeout(() => {
                window.location.href = href;
            }, 100);
        }
    });
});
